const hasZeroMinutesInCourses = (courses) => {
  return courses.some((course) => course.averageMinutesPerWeek === 0)
}
export default hasZeroMinutesInCourses
